var map = {
	"./Default": 27830,
	"./Default.tsx": 27830,
	"./Detailed": 50301,
	"./Detailed.tsx": 50301,
	"./Mobiletwoitems": 72517,
	"./Mobiletwoitems.tsx": 72517,
	"./type": 65431,
	"./type.ts": 65431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58023;